
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v3-migration",
      function () {
        return require("private-next-pages/v3-migration.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v3-migration"])
      });
    }
  